import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"
import {
  Window,
  WindowContent,
  Fieldset,
  Divider,
  List,
  ListItem,
  Anchor,
  Button,
  Tabs,
  TabBody,
  Tab,
  Checkbox,
  NumberField,
} from "react95"

class IndexPage extends React.Component {
  state = {
    activeTab: 0,
  }

  handleChange = tab => {
    this.setState({
      activeTab: tab,
    })
  }
  render() {
    let activeTab = this.state.activeTab
    return (
      <Layout>
        <SEO title="Home" keywords={[`gatsby`, `application`, `react`]} />
        <br />
        <br />
        <br />
        <Window style={{ width: "100%" }}>
          <WindowContent>
            <Fieldset label="Nyan Win">
              <img src={'static/download1.png'} style={{ height: "14rem", borderRadius: 3}}/>
              <br/>
              <br/>
              A programmer who is chasing his infinite dreams. When i failed, I
              will train, try try and try again !
              <br />
              <br />
              Are you willing to do the same ?
              <br />
              <br />I write tech staff at ✍️
              <Anchor href="https://medium.com/@pyaesonenyein" target="_blank">
                {" "}
                Medium{" "}.
              </Anchor>
              <br/>
              <br/>
              You can find my open source contributions on 🚀
              <Anchor href="https://github.com/pyaesone17" target="_blank">
                {" "}
                Github{" "}.
              </Anchor>
              <br/>
              <br/>
              You can reach me via ☎️
              <Anchor
                href="https://www.linkedin.com/in/nyan-win-605712b9/"
                target="_blank"
              >
                {" "}
                Linkedin{" "}.
              </Anchor>
            </Fieldset>
          </WindowContent>
        </Window>
        <br />
        <br />
        <br />

        <Window style={{ width: "100%" }}>
          <WindowContent>
            <Fieldset label="My Skills Included">
                Go, grpc<br/><br/>
                PHP, Laravel<br/><br/>
                Javascript, React, Vue, Pure<br/><br/>
                AWS, Kubernetes, Cloud Native Development<br/><br/>
            </Fieldset>
          </WindowContent>
        </Window>
        <br />
        <br />
        <br />
        <Window style={{ width: "100%" }}>
          <WindowContent>
            <Fieldset label="My Experiences Are">
              Simonestudios 🔥
              <br />
              <br />
              AiryNo 💥
              <br />
              <br />
              NewChallenges ✨
              <br />
              <br />
              Myanmar Link ⚡️
            </Fieldset>
          </WindowContent>
        </Window>
        <br />
        <br />
        <br />

        <Tabs value={activeTab} onChange={this.handleChange}>
          <Tab value={0}>Vuex</Tab>
          <Tab value={1}>Laravel</Tab>
          <Tab value={2}>Eloquent</Tab>
        </Tabs>
        <div style={{ minHeight: 300, maxHeight: 500 }}>
          {activeTab === 0 && (
            <TabBody>
              <div>
                I was invited to talk about predictable state management with
                vue js. The topic I discussed was imperative vs declrative, three types of sharing state,
                vuex basic and core concept, when to use local state in vuex, when single source of truth
                is not true anymore and vuex advance patterns.
              </div>
              <br />
              <img
                src={"static/talk1-2cc2a30706bb09576f157ce9891fb476.jpg"}
                style={{
                  width: "50%",
                  height: "auto",
                }}
              />
              <br />
            </TabBody>
          )}
          {activeTab === 1 && (
            <TabBody>
              {" "}
              <div>I am glad that I have a chance to talk at UCSY IT CAMP. 
                It is very honourable moment for me because I am self taught developer for computer science.
                Mostly I disscussed about how to learn programming and deep dive framework.
              </div>
              <br />
              <img
                src={"static/talk2-18ad1367edd7b929de4ab57abb0709b6.jpg"}
                style={{
                  width: "50%",
                  height: "auto",
                }}
              />
            </TabBody>
          )}
          {activeTab === 2 && (
            <TabBody>
              {" "}
              <div>
                This is my very first public talk. Even though I was nervous, I
                think I did very well. The title was Digging into Eloquent ORM.
              </div>
              <br />
              <div>
              <img
                src={"static/talk3-22918d6151f6064e33f97a30c28f1f82.jpg"}
                style={{
                  width: "50%",
                  height: "auto",
                }}
              />
              </div>
            </TabBody>
          )}
        </div>

        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </Layout>
    )
  }
}

export default IndexPage
